import {
  fabuildingsclassicregular,
  fafilechartcolumnclassicregular,
  fafilecirclecheckclassicregular,
  fafileinvoicedollarclassicregular,
  fagearclassicregular,
  fahouseclassicregular
} from '@grc/ui-package';

export const MenuItems = [
  {
    id: '1',
    parentId: 0,
    text: 'My Work Items',
    path: '/myworkitems',
    icon: fahouseclassicregular,
    expanded: false
  },
  {
    id: '2',
    parentId: 0,
    text: 'Load Management',
    path: '/loadmanagement',
    icon: fabuildingsclassicregular,
    expanded: false
  },
  {
    id: '2_1',
    parentId: '2',
    text: 'All Loads',
    path: '/loadmanagement/allloads',
    icon: '',
    expanded: true
  },
  {
    id: '2_2',
    parentId: '2',
    text: 'Load Board',
    path: '/loadmanagement/loadboard',
    icon: '',
    expanded: true
  },
  {
    id: '2_3',
    parentId: '2',
    text: 'Loads Summary',
    path: '/loadmanagement/loadsummary',
    icon: '',
    expanded: true
  },

  {
    id: '3',
    parentId: 0,
    text: 'Compliance',
    path: '/compliance',
    icon: fafilechartcolumnclassicregular,
    expanded: false
  },

  {
    id: '4',
    parentId: 0,
    text: 'Contracts',
    path: '/contracts',
    icon: fafilecirclecheckclassicregular,
    expanded: false
  },

  {
    id: '5',
    parentId: 0,
    text: 'Invoices',
    path: '/invoices',
    icon: fafileinvoicedollarclassicregular,
    expanded: false
  },
  {
    id: '6',
    parentId: 0,
    text: 'Score Card',
    path: '/scorecard',
    icon: fabuildingsclassicregular,
    expanded: false
  },
  {
    id: '7',
    parentId: 0,
    text: 'Settings',
    path: '/settings',
    icon: fagearclassicregular,
    expanded: false
  }
];

export interface ProductType {
  id: string;
  text: string;
  parentId: number;
  items?: ProductType[];
  icon?: any;
  expanded?: boolean;
  image?: string;
  price?: number;
}


export function getMenuItemTextByPath(path: string): string {
  const findMenuItem = (items: any[], path: string): any => {
    for (const item of items) {
      if (item.path === path) {
        return item;
      }
      if (item.items) {
        const found = findMenuItem(item.items, path);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  const menuItem = findMenuItem(MenuItems, path);
  if (menuItem) {
    if (menuItem.parentId !== 0) {
      const parentItem = MenuItems.find(item => item.id === menuItem.parentId);
      return parentItem ? parentItem.text : menuItem.text;
    }
    return menuItem.text;
  }
  return '';
}

export function getMenuItemNameWithPath(path: string): string {
  const findMenuItem = (items: any[], path: string): any => {
    let foundItem = null;
    for (const item of items) {
      if (item.path === path) {
        if (!foundItem || item.parentId !== 0) {
          foundItem = item;
        }
      }
      if (item.items) {
        const found = findMenuItem(item.items, path);
        if (found) {
          if (!foundItem || found.parentId !== 0) {
            foundItem = found;
          }
        }
      }
    }
    return foundItem;
  };

  const menuItem = findMenuItem(MenuItems, path);
  return menuItem ? menuItem.text : '';
}
